import * as React from "react";
import styled from "styled-components";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Grid from "@mui/material/Grid";
import request from "src/utils/request";
import { Button, ListItemButton, Paper, Stack } from "@mui/material";
import AvatarBadge from "src/components/avatar-badge";
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ToastContext } from "src/components/providers/toast-provider";
import { format } from "date-fns";

const SubscriptionPaper = styled(Paper)`
    border-radius: 14px;
`;
const MainText = styled.p`
    font-size: 12px;
    margin: 0;
`;
const SecondaryText = styled.p`
    font-size: 11px;
    font-weight: 300;
    opacity: 0.7;
    margin: 0;
`;
const CardTitle = styled.span`
    font-size: 18px;
    font-weight: 500;
    padding: 4px 0px 4px;
`;
const RemoveButton = styled(Button)`
    font-size: 12px;
    font-weight: 400;
    text-transform: none;
    color: ${({ theme }) => theme.palette.warning.main};
`;

const PendingInvitesPlanList = ({ subscription, planMembersApi }) => {
    if (!subscription) return null;
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const [data, setData] = React.useState(" ");
    const [checked, setChecked] = React.useState([]);

    React.useEffect(() => {
        setData(planMembersApi.data && planMembersApi.data.pendingMembers);
    }, [planMembersApi.status]);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleCancelInvite = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            const invitesToCancel = checked.map((item) => ({
                targetUnit: item.targetUnit || "*",
                hashedEmail: item.hashedEmail,
            }));
            await request(`/api/invites`, {
                method: "DELETE",
                body: JSON.stringify(invitesToCancel),
            });
            setMessage(`Successfully canceled invitations to ${subscription.name} Plan`);
            setSeverity("success");
            setIsToastTriggered(true);
            setChecked([]);
            planMembersApi.refetch();
        } catch (error) {
            setMessage(`Failed to cancel invitations to ${subscription.name} Plan.`);
            setSeverity("error");
            setIsToastTriggered(true);
            setChecked([]);
        }
    };

    if (planMembersApi && planMembersApi.status !== "SUCCESS") return null;
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <SubscriptionPaper>
                    <Stack direction="column">
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            style={{ padding: "17px 26px 9px" }}
                        >
                            <CardTitle>Manage pending invitations</CardTitle>
                            {checked.length > 0 && (
                                <RemoveButton onClick={handleCancelInvite}>
                                    Cancel invite
                                </RemoveButton>
                            )}
                        </Stack>
                        <List
                            dense
                            sx={{
                                width: "100%",
                                maxHeight: "22rem",
                                overflow: "auto",
                                paddingBottom: "28px",
                            }}
                        >
                            {data &&
                                data.map((member) => {
                                    return (
                                        <ListItem key={member}>
                                            <ListItemButton
                                                role={undefined}
                                                onClick={handleToggle(member)}
                                                dense
                                            >
                                                <ListItemIcon style={{ minWidth: "48px" }}>
                                                    <Checkbox
                                                        checked={checked.indexOf(member) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        size="small"
                                                        inputProps={{
                                                            "aria-labelledby": "label",
                                                        }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemAvatar>
                                                    <AvatarBadge
                                                        style={{ marginRight: "16px" }}
                                                        name={member.email}
                                                        picture={member.picture}
                                                    />
                                                </ListItemAvatar>
                                                <Stack direction="column">
                                                    <MainText>{member.email}</MainText>
                                                    <SecondaryText>
                                                        Invited by {member.invitedBy.givenName}{" "}
                                                        {member.invitedBy.familyName} on{" "}
                                                        {member.invitedOn &&
                                                            format(
                                                                new Date(member.invitedOn * 1000),
                                                                "EEEE dd MMMM yyyy"
                                                            )}
                                                    </SecondaryText>
                                                </Stack>
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </Stack>
                </SubscriptionPaper>
            </Grid>
        </Grid>
    );
};

export default PendingInvitesPlanList;
